import React, { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BarChart3, Download, RefreshCw } from "lucide-react";
import { UsageTable } from "@/components/usage/UsageTable";
import { EngagementSettings } from "@/components/usage/EngagementSettings";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Kpi = ({ label, value, hint, tone, testid }) => (
  <Card className={`px-3.5 py-3 glow-border min-w-0 ${tone === "amber" ? "border-amber-500/40" : tone === "red" ? "border-red-500/40" : ""}`} data-testid={testid}>
    <p className="text-xl font-head font-bold leading-tight truncate">{value}</p>
    <p className="text-xs text-muted-foreground leading-snug [overflow-wrap:anywhere]">{label}{hint && <span className="opacity-70"> · {hint}</span>}</p>
  </Card>
);

export default function AdminDealerUsage() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/dealer-usage").then((r) => setD(r.data)).catch(() => toast.error("Report non disponibile"));
  useEffect(() => { load(); }, []);
  const s = d?.summary || {};
  return (
    <div className="space-y-4" data-testid="dealer-usage-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-primary"><BarChart3 className="w-5 h-5" /><span className="text-xs font-medium tracking-wider uppercase">Rete</span></div>
          <h1 className="font-head text-2xl md:text-3xl font-bold tracking-tight mt-1">Utilizzo dealer</h1>
          <p className="text-sm text-muted-foreground mt-1">Chi usa davvero la piattaforma, quanto credito resta fermo e chi è vicino alla sospensione.</p>
        </div>
        <div className="flex gap-2 compact-actions">
          <Button variant="outline" size="sm" className="gap-1.5" onClick={load} data-testid="dealer-usage-refresh"><RefreshCw className="w-4 h-4" /> Aggiorna</Button>
          <Button asChild size="sm" variant="outline" className="gap-1.5" data-testid="dealer-usage-csv"><a href={`${BACKEND}/api/admin/dealer-usage?format=csv`}><Download className="w-4 h-4" /> Esporta CSV</a></Button>
        </div>
      </div>
      {d && <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-8 gap-2.5" data-testid="dealer-usage-kpis">
        <Kpi label="Dealer" value={s.dealers} testid="usage-kpi-dealers" />
        <Kpi label="Attivi ultimi 30 gg" value={s.active_30} testid="usage-kpi-active" />
        <Kpi label="Inattivi 60+ gg" value={s.inactive_60} hint={`30+: ${s.inactive_30}`} tone={s.inactive_60 ? "amber" : ""} testid="usage-kpi-inactive-60" />
        <Kpi label="Inattivi 180+ gg" value={s.inactive_180} hint={`12 mesi+: ${s.inactive_365}`} tone={s.inactive_180 ? "amber" : ""} testid="usage-kpi-inactive-180" />
        <Kpi label="Sospesi per inattività" value={s.suspended} hint={`${s.reactivation_requests} chiedono riattivazione`} tone={s.suspended ? "red" : ""} testid="usage-kpi-suspended" />
        <Kpi label="Penali da confermare" value={s.penalty_due} tone={s.penalty_due ? "red" : ""} testid="usage-kpi-penalty" />
        <Kpi label="Credito residuo" value={euro(s.credit_total)} hint={`bonus ${euro(s.bonus_total)}`} testid="usage-kpi-credit" />
        <Kpi label="Credito fermo 180+ gg" value={euro(s.credit_idle_180)} tone={s.credit_idle_180 ? "amber" : ""} testid="usage-kpi-idle-credit" />
      </div>}
      {!d && <p className="text-muted-foreground" data-testid="dealer-usage-loading">Caricamento…</p>}
      {d && <UsageTable rows={d.rows} onChanged={load} />}
      {d && <EngagementSettings key={JSON.stringify(d.settings)} initial={d.settings} onSaved={load} />}
    </div>
  );
}
